import React, { useRef, useEffect } from 'react';
import profileImage from '../images/profile-image.svg';
import logout from '../images/icon-logout.svg';
import { VscClose } from 'react-icons/vsc';
import * as securityHelper from "../helper/SecurityHelper";
import { useNavigate } from "react-router-dom";

export default function Sidebar({ setSidebar, setTerms1, setTerms3, setPassCard }: any) {
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // 이벤트 핸들러 함수
    const handler = (e: any) => {
      // mousedown 이벤트가 발생한 영역이 모달창이 아닐 때, 모달창 제거 처리
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setSidebar(false);
      }
    };
    // 이벤트 핸들러 등록
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler); // 모바일 대응
    return () => {
      // 이벤트 핸들러 해제
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler); // 모바일 대응
    };
  });

  const fn_moveToMyPage = () => {
    navigate('/mypage');
  }

  return (
    <div className='w-full h-full absolute flex justify-end bg-black bg-opacity-[70%] z-[990]'>
      <div ref={modalRef} className='w-[200px] sm:w-[260px] md:w-[650px] h-full bg-[#F6F7F9] flex flex-col'>
        <div className='w-full h-124 md:h-[310px] bg-[#1F1F23] text-white flex flex-col'>
          <div className='flex justify-end'><VscClose onClick={() => setSidebar(false)} className='hover:cursor-pointer mt-11 md:mt-27 mr-10 sm:mr-18 md:mr-[45px] text-22 md:text-[55px]' /></div>
          <div className='flex items-center'>
            <img src={user.prflAtchFileId ? 'admin/api/cmmn/fileDownload?atchFileId=' + user.prflAtchFileId + '&fileSn=0' : profileImage} alt='profile' className='w-56 h-56 md:w-[140px] md:h-[140px] mr-15 md:mr-[37px] rounded-full bg-white ml-15 sm:ml-24 md:ml-60 ' />
            <div className='flex flex-col text-14 leading-16 md:text-35 md:leading-40 ont-preLight'><p className='mb-6 md:mb-15'>{user.name}</p><p className='truncate'>{user.companyName !== '' ? user.companyName : '-'}</p></div>
          </div>
        </div>
        <div className='flex justify-center'><div className='w-168 sm:w-[228px] md:w-[570px] border border-x-0 border-t-0 border-[#DDDDDD]' /></div>
        {user.auth === 'SRV' && <>
          <div onClick={() => setPassCard(true)} className='w-full h-48 md:h-[120px] bg-white text-[#272931] text-14 leading-17 md:text-35 md:leading-42 flex items-center' ><p className='ml-22 md:ml-[55px]'>내 출입증 확인</p></div>
          <div className='flex justify-center'><div className='w-168 sm:w-[228px] md:w-[570px] border border-x-0 border-t-0 border-[#DDDDDD]' /></div>
        </>}
        <div className='w-full h-48 md:h-[120px] bg-white text-[#272931] text-14 leading-17 md:text-[35px] md:leading-42 flex items-center' onClick={fn_moveToMyPage}><p className='ml-22 md:ml-[55px]'>마이페이지</p></div>
        <div className='flex justify-center'><div className='w-168 sm:w-[228px] md:w-[570px] border border-x-0 border-t-0 border-[#DDDDDD]' /></div>
        <div onClick={() => setTerms1(true)} className='w-full h-48 md:h-[120px] bg-white text-[#272931] text-14 leading-17 md:text-35 md:leading-42 flex items-center'><p className='ml-22 md:ml-[55px]'>서비스 이용 약관</p></div>
        <div className='flex justify-center'><div className='w-168 sm:w-[228px] md:w-[570px] border border-x-0 border-t-0 border-[#DDDDDD]' /></div>
        <div onClick={() => setTerms3(true)} className='w-full h-48 md:h-[120px] bg-white text-[#272931] text-14 leading-17 md:text-35 md:leading-42 flex items-center'><p className='ml-22 md:ml-[55px]'>개인정보 처리 방침</p></div>
        <div onClick={securityHelper.logout} className='flex justify-end items-center mt-12 mr-18 text-13 leading-16 md:mt-[30px] md:mr-[45px] md:text-[32px] md:leading-[40px] text-[#B1B1B1]'><img src={logout} alt='logout' className='mr-6 md:mr-[19px] md:w-[32px]' /><p className='mt-2 md:mt-[5px]'>로그아웃</p></div>
        <div className='text-center mt-auto mb-17 text-8 leading-9 md:mb-[42px] md:text-[20px] md:leading-[22px] whitespace-pre-line tracking-[-0.08em] sm:tracking-[-0.1em] font-preLight text-[#9D9D9C]'>Copyright © 2023 by GSIL Co., Ltd.<p className='block sm:hidden mt-6 sm:mt-0'>{'\n'}</p> All rights reserved.</div>
      </div>
    </div>
  );
}

